import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a900314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"0.5rem"} }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "客户风控管理")
], -1))
const _hoisted_3 = { class: "grid-8 mb-1" }
const _hoisted_4 = { class: "card padding-bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "逾期客户数", -1))
const _hoisted_6 = { class: "text-big-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "text-small",
  style: {"font-size":"12px"}
}
const _hoisted_9 = { class: "card padding-bg" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "逾期金额（万元）", -1))
const _hoisted_11 = { class: "text-big-title" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "text-small",
  style: {"font-size":"12px"}
}
const _hoisted_14 = { class: "card padding-bg" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "逾期率", -1))
const _hoisted_16 = { class: "text-big-title" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  class: "text-small",
  style: {"font-size":"12px"}
}
const _hoisted_19 = { class: "card padding-bg" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "逾期60天以上金额环比", -1))
const _hoisted_21 = { class: "text-big-title" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "card padding-bg" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "有额度客户代码数", -1))
const _hoisted_25 = { class: "text-big-title" }
const _hoisted_26 = { class: "card padding-bg" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "固定额度（万元）", -1))
const _hoisted_28 = { class: "text-big-title" }
const _hoisted_29 = { class: "card padding-bg" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "实际授信系数", -1))
const _hoisted_31 = { class: "text-big-title" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  class: "text-small",
  style: {"font-size":"12px"}
}
const _hoisted_34 = { class: "card padding-bg" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-small" }, "已使用固定额度占比", -1))
const _hoisted_36 = { class: "text-big-title" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  class: "text-small",
  style: {"font-size":"12px"}
}
const _hoisted_39 = { class: "grid-3 mb-1" }
const _hoisted_40 = {
  class: "card mb-1",
  style: {"padding":"10px 0"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label mx-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "各逾期账龄的逾期金额分布"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-subtitle",
    style: {"color":"#5B687D"}
  }, "单位：万元")
], -1))
const _hoisted_42 = {
  class: "card mb-1",
  style: {"padding":"10px 0"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label mx-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "各管控方式可用主体数量分布")
], -1))
const _hoisted_44 = {
  class: "card mb-1",
  style: {"padding":"10px 0"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label mx-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "各固定额度规则类型分布情况"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-subtitle",
    style: {"color":"#5B687D"}
  }, "单位：万元")
], -1))
const _hoisted_46 = { class: "grid-2" }
const _hoisted_47 = { class: "card" }
const _hoisted_48 = { class: "board-top-label mx-12 pt-12" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "客户逾期趋势", -1))
const _hoisted_50 = { class: "from-box" }
const _hoisted_51 = { class: "card" }
const _hoisted_52 = { class: "board-top-label mx-12 pt-12" }
const _hoisted_53 = { class: "from-box" }

import BoardPieChart from './componects/BoardPieChart.vue'
import BoardLineChart from './componects/BoardLineChart.vue'
import { ref, onMounted, toRef, watch, PropType } from 'vue'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'

import riseImage from '@/assets/rise.png';
import declineImage from '@/assets/decline.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'tab4',
  props: {
  formState: {
    type: Object as PropType<Object>,
  }
},
  setup(__props) {

const props = __props

const formState = toRef(props, 'formState')

watch(() => props.formState, (newValue) => {
  formState.value = newValue
  fetchData()
})

const riskDashboard = ref({})
const overdueAmountTypeList = ref([])
const creditControlTypeList = ref([])
const fixedLimitRuleTypeList = ref([])
const fetchData = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/dashboard', formState.value).then((res) => {
    riskDashboard.value = res.data
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/overdueAmountType', formState.value).then((res) => {
    const { overdueAmountType } = res.data
    overdueAmountTypeList.value = [
      { name: '1-30天', value: overdueAmountType?.apartAmount || 0 },
      { name: '31-60天', value: overdueAmountType?.bpartAmount || 0 },
      { name: '61-90天', value: overdueAmountType?.cpartAmount || 0 },
      { name: '91-180天', value: overdueAmountType?.dpartAmount || 0 },
      { name: '181-360天', value: overdueAmountType?.epartAmount || 0 },
      { name: '360天以上', value: overdueAmountType?.fpartAmount || 0 }
    ]
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/creditControlType', formState.value).then((res) => {
    const { creditControlType } = res.data
    creditControlTypeList.value = [
      { name: '额度管控', value: creditControlType?.creditControlType1 || 0 },
      { name: '账期管控', value: creditControlType?.creditControlType2 || 0 }
    ]
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/fixedLimitRuleType', formState.value).then((res) => {
    const { fixedLimitRuleType } = res.data
    fixedLimitRuleTypeList.value = [
      { name: '申请金额-转运客户', value: fixedLimitRuleType?.transportQuota || 0 },
      { name: '申请金额-仓储新客', value: fixedLimitRuleType?.newStorageQuota || 0 },
      { name: '申请金额-仓储老客', value: fixedLimitRuleType?.oldStorageQuota || 0 },
      { name: '申请系数-标准系数', value: fixedLimitRuleType?.standardCoeff || 0 },
      { name: '申请系数-非标准系数', value: fixedLimitRuleType?.nonStandardCoeff || 0 }
    ]
  })

  fetchOverdue()
  fetchCredit()
}

const overdueRef = ref({
  dateQueryType: 3,
  dataType: 1
})

const yearOverdue = ref<Dayjs>(dayjs())
const weakOverdue = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayOverdue = ref<Dayjs>(dayjs().startOf('month'))
const overdueList = ref([])
const fetchOverdue = () => {
  const p = {}
  p.employeeNo = formState.value.employeeNo
  p.dataPermissionQueryType = formState.value.dataPermissionQueryType
  p.dateQueryType = overdueRef.value.dateQueryType

  if (p.dateQueryType === 3) {
    p.startMonth = dayjs(yearOverdue.value).format('YYYY01')
    p.endMonth = dayjs(yearOverdue.value).format('YYYY12')
  } else if (p.dateQueryType === 2) {
    p.startWeek = dayjs(weakOverdue.value[0]).format('YYYYww')
    p.endWeek = dayjs(weakOverdue.value[1]).format('YYYYww')
  } else {
    p.startDay = dayjs(dayOverdue.value.startOf('month')).format('YYYY/MM/DD')
    p.endDay = dayjs(dayOverdue.value.endOf('month')).format('YYYY/MM/DD')
  }
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/overdueRateList', p).then((res) => {
    overdueList.value = generateOverdueList(p, res.data?.overdueList || [])
  })
}
const generateOverdueTips = (item: any) => {
  return overdueRef.value.dataType === 1 ? `逾期率 <span style="font-weight: bolder;font-size: 16px">${(item?.overdueRate || '0%')}</span>` : `逾期金额 <span style="font-weight: bolder;font-size: 16px">${item?.overdueAmount || 0}</span>`
}
const generateOverdueList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearOverdue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>${generateOverdueTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakOverdue.value[0])
    const lastDay = dayjs(weakOverdue.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayOverdue.value.startOf('month'))
    const lastDay = dayjs(dayOverdue.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

const creditRef = ref({
  dateQueryType: 3,
  dataType: 0
})
const yearCredit = ref<Dayjs>(dayjs())
const weakCredit = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayCredit = ref<Dayjs>(dayjs().startOf('month'))
const creditList = ref([])

const fetchCredit = () => {
  const p = {}
  p.employeeNo = formState.value.employeeNo
  p.dataPermissionQueryType = formState.value.dataPermissionQueryType
  p.dateQueryType = creditRef.value.dateQueryType

  if (p.dateQueryType === 3) {
    p.startMonth = dayjs(yearCredit.value).format('YYYY01')
    p.endMonth = dayjs(yearCredit.value).format('YYYY12')
  } else if (p.dateQueryType === 2) {
    p.startWeek = dayjs(weakCredit.value[0]).format('YYYYww')
    p.endWeek = dayjs(weakCredit.value[1]).format('YYYYww')
  } else {
    p.startDay = dayjs(dayCredit.value.startOf('month')).format('YYYY/MM/DD')
    p.endDay = dayjs(dayCredit.value.endOf('month')).format('YYYY/MM/DD')
  }
  request.post<AxiosResult, AxiosResult>(creditRef.value.dataType === 1 ? '/fbu/api/report/risk/usedQuotaRateList' : '/fbu/api/report/risk/creditCoefficientList', p).then((res) => {
    creditList.value = generateCreditList(p, res.data?.creditCoefficientList || res.data?.usedQuotaRateList || [])
  })
}

const generateCreditTips = (item: any) => {
  return creditRef.value.dataType === 1 ? `已使用固定额度占比 <span style="font-weight: bolder;font-size: 16px">${(item?.usedQuotaRate || '0%')}</span>` : `实际授信系数 <span style="font-weight: bolder;font-size: 16px">${item?.creditCoefficient || '0'}</span>`
}
const generateCreditList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearCredit.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>${generateCreditTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakOverdue.value[0])
    const lastDay = dayjs(weakOverdue.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayOverdue.value.startOf('month'))
    const lastDay = dayjs(dayOverdue.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

function convertPercentageToNumber(percentageString: string): number {
  if (!percentageString) {
    return 0
  }
  const noPercentage = percentageString.replace(/%/, '').replaceAll(',', '')
  return Number(noPercentage) / 100
}

const imageByCompare = (num1: number, num2: number) => {
  if (num1 > num2) {
    return '<img src="' + riseImage + '" class="icon icon-right" alt="" />'
  } else if (num1 < num2) {
    return '<img src="' + declineImage + '" class="icon icon-right" alt="" />'
  } else {
    return ''
  }
}

onMounted(() => {
  fetchData()
})



return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(riskDashboard.value.overdueCustomer || 0), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(riskDashboard.value.overdueCustomer, riskDashboard.value.lastOverdueCustomer)
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("p", _hoisted_8, "上月逾期客户数 " + _toDisplayString(riskDashboard.value.lastOverdueCustomer || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("p", _hoisted_11, [
          _createTextVNode(_toDisplayString(_unref(formatThousandSeparator)(riskDashboard.value.overdueAmount)), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(riskDashboard.value.overdueAmount, riskDashboard.value.lastOverdueAmount)
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("p", _hoisted_13, "上月逾期金额 " + _toDisplayString(_unref(formatThousandSeparator)(riskDashboard.value.lastOverdueAmount)), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("p", _hoisted_16, [
          _createTextVNode(_toDisplayString(riskDashboard.value.overdueRate), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(riskDashboard.value.overdueRate, riskDashboard.value.lastOverdueRate)
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("p", _hoisted_18, "上月逾期率 " + _toDisplayString(riskDashboard.value.lastOverdueRate), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, [
          _createTextVNode(_toDisplayString(riskDashboard.value.cdefPartRate), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(riskDashboard.value.cdefPartAmount, riskDashboard.value.lastCdefPartAmount)
          }, null, 8, _hoisted_22)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(formatThousandSeparator)(riskDashboard.value.haveQuotaCustomer)), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(formatThousandSeparator)(riskDashboard.value.fixedQuota)), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("p", _hoisted_31, [
          _createTextVNode(_toDisplayString(riskDashboard.value.creditCoefficient), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(convertPercentageToNumber(riskDashboard.value.creditCoefficient), convertPercentageToNumber(riskDashboard.value.lastCreditCoefficient))
          }, null, 8, _hoisted_32)
        ]),
        _createElementVNode("p", _hoisted_33, "上月 " + _toDisplayString(riskDashboard.value.lastCreditCoefficient), 1)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("p", _hoisted_36, [
          _createTextVNode(_toDisplayString(riskDashboard.value.usedQuotaRate), 1),
          _createElementVNode("span", {
            innerHTML: imageByCompare(convertPercentageToNumber(riskDashboard.value.usedQuotaRate), convertPercentageToNumber(riskDashboard.value.lastUsedQuotaRate))
          }, null, 8, _hoisted_37)
        ]),
        _createElementVNode("p", _hoisted_38, "上月 " + _toDisplayString(riskDashboard.value.lastUsedQuotaRate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode(BoardPieChart, {
          height: "230px",
          data: overdueAmountTypeList.value
        }, null, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createVNode(BoardPieChart, {
          height: "230px",
          data: creditControlTypeList.value
        }, null, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createVNode(BoardPieChart, {
          height: "230px",
          showLabel: false,
          data: fixedLimitRuleTypeList.value
        }, null, 8, ["data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            (overdueRef.value.dateQueryType === 3)
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 0,
                  value: yearOverdue.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((yearOverdue).value = $event)),
                  allowClear: false,
                  onChange: fetchOverdue,
                  picker: "year"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (overdueRef.value.dateQueryType === 2)
              ? (_openBlock(), _createBlock(_component_a_range_picker, {
                  key: 1,
                  value: weakOverdue.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((weakOverdue).value = $event)),
                  allowClear: false,
                  picker: "week",
                  onChange: fetchOverdue
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (overdueRef.value.dateQueryType === 1)
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 2,
                  value: dayOverdue.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dayOverdue).value = $event)),
                  allowClear: false,
                  onChange: fetchOverdue,
                  picker: "month"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_radio_group, {
              value: overdueRef.value.dateQueryType,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((overdueRef.value.dateQueryType) = $event)),
              style: {"margin-left":"20px"},
              onChange: fetchOverdue
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("天")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode("周")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode("月")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_component_a_radio_group, {
              value: overdueRef.value.dataType,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((overdueRef.value.dataType) = $event)),
              style: {"margin-left":"20px"},
              onChange: fetchOverdue
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("逾期率")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode("逾期金额")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _createVNode(BoardLineChart, {
          height: "280px",
          data: overdueList.value,
          isPercentageY: overdueRef.value.dataType === 1
        }, null, 8, ["data", "isPercentageY"])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_a_radio_group, {
            value: creditRef.value.dataType,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((creditRef.value.dataType) = $event)),
            onChange: fetchCredit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_button, { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("实际授信系数")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio_button, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("已使用固定额度占比")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createElementVNode("div", _hoisted_53, [
            (creditRef.value.dateQueryType === 3)
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 0,
                  value: yearCredit.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((yearCredit).value = $event)),
                  allowClear: false,
                  onChange: fetchCredit,
                  picker: "year"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (creditRef.value.dateQueryType === 2)
              ? (_openBlock(), _createBlock(_component_a_range_picker, {
                  key: 1,
                  value: weakCredit.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((weakCredit).value = $event)),
                  allowClear: false,
                  picker: "week",
                  onChange: fetchCredit
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (creditRef.value.dateQueryType === 1)
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 2,
                  value: dayCredit.value,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dayCredit).value = $event)),
                  allowClear: false,
                  onChange: fetchCredit,
                  picker: "month"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_radio_group, {
              value: creditRef.value.dateQueryType,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((creditRef.value.dateQueryType) = $event)),
              style: {"margin-left":"20px"},
              onChange: fetchCredit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("天")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode("周")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode("月")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _createVNode(BoardLineChart, {
          height: "280px",
          data: creditList.value,
          isPercentageY: creditRef.value.dataType === 1
        }, null, 8, ["data", "isPercentageY"])
      ])
    ])
  ]))
}
}

})